import { configureSlices } from "utils/store/configureSlices";

import bidAwardUiSlice from "./bidAwardUiSlice";
import contractListSlice from "./contractListSlice";

export const { useSlices: useBidAwardSlices, useSliceSelector: useBidAwardSliceSelector } = configureSlices({
  bidAwardUiSlice,
  contractListSlice,
});
